module.exports = __webpack_public_path__ + "img/1490442774.b005f88d.jpg";